import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"
import { toast } from "react-toastify";

// Create course
export const createFeedback = data => post(url.CREATE_FEEDBACK, data);
export const deleteFeedback = id => del(url.DELETE_FEEDBACK + id);
export const fetchAllFeedbackOfBatch = id => get(url.GET_ALL_FEEDBACK_OF_BATCH + id);
export const getAllResponsesOfFeedback = id => get(url.GET_ALL_RESPONSE_OF_FEEDBACK + id);
